import { css } from 'linaria';

// HACK: Удалить !important после фикса NAVI-4853
// HACK: Drawer блокирует клики по Hint-у, возвращаем pointer-events
export const MobileSnackbarClassName = css`
  &[data-focus-on-hidden='true'] {
    pointer-events: auto !important;
  }
  @media (--only-mobile) {
    bottom: 51px !important;
    padding-bottom: 0 !important;
  }
`;
